import { render, staticRenderFns } from "./Calculate.vue?vue&type=template&id=51e5d1f2&scoped=true"
import script from "./Calculate.vue?vue&type=script&lang=js"
export * from "./Calculate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51e5d1f2",
  null
  
)

export default component.exports